import { makeSredDetailsDescription, SredDocumentationStatus } from '@neo.tax/sred/utils/sred-project.utils';

import { SredDocumentationBadgeConfig } from './sred-projects-layout.types';

export const getSredDetailsBadgeConfig = (
  consideredForSred: boolean,
  sredDocumentationStatus: SredDocumentationStatus,
): SredDocumentationBadgeConfig | undefined => {
  if (!consideredForSred) {
    return;
  }

  const hasAllDocumentation = Object.values(sredDocumentationStatus).every(Boolean);

  if (hasAllDocumentation) {
    return {
      colorVariant: 'default',
      label: 'Complete',
      description: 'Has all required supporting documentation.',
    };
  }

  return {
    colorVariant: 'red',
    label: 'Incomplete',
    description: makeSredDetailsDescription(sredDocumentationStatus),
  };
};
